import theme from '@ifca-root/react-component/src/assets/theme'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import {
  StyledMenu,
  StyledMenuItem,
} from '@ifca-root/react-component/src/components/others/Menu'
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { dropdownOption } from 'containers/DigitalReportModule/function/DigitalReportDropdown'
import { useLazyQuery } from '@apollo/react-hooks'
import { GET_PACKAGE_BY_ACCOUNT } from 'containers/AccountModule/GraphQL/AccountQuery'
import { SubscriptionClient } from 'SubscriptionClient'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { AcctPermission } from '@account-root/procurement-react/src/generated/graphql'

export const ARDigitalReportSubmenu = (props: any) => {
  let history = useHistory()
  const location = useLocation()
  const isHomeDefault = localStorage.getItem('isDefault')
  const CompanyID = localStorage.getItem('latestCompany')
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { handlePermHidden } = usePermissionChecker()
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const [labelState, setLabelState] = useState<string>(
    'Account Receivable Reports'
  )
  const { mode } = props
  // ACCOUNTX API CALLS
  const [
    loadPackage,
    {
      loading: packageLoading,
      data: { getPackageByAccount } = { getPackageByAccount: [] },
    },
  ] = useLazyQuery(GET_PACKAGE_BY_ACCOUNT, { client: SubscriptionClient })

  const isInternalUse =
    process.env.REACT_APP_LOCAL_DB === 'local' ||
    process.env.REACT_APP_LOCAL_DB === 'internal' ||
    process.env.REACT_APP_LOCAL_DB === 'azure' ||
    process.env.REACT_APP_LOCAL_DB === 'axifcadev'

  const submenuList = [
    {
      path: `/digital-reports/account-receivable/ar-consolidated-einvoice/parameters`,
      title: `Consolidated E-Invoice`,
      permission:
        AcctPermission.AccReceivableDigitalReportsEinvoiceListingReportView,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-debtor-ledger-detail-by-doc-date/parameters`,
      title: `Debtor Ledger Detail By Doc Date`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-debtor-ledger-detail-by-trx-date/parameters`,
      title: `Debtor Ledger Detail By Transaction Date`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-statement-of-account/parameters`,
      title: `Statement Of Account`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-debtor-aging-summary-trx-date/parameters`,
      title: `Debtor Aging Summary by Trx Date`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-debtor-aging-summary-doc-date/parameters`,
      title: `Debtor Aging Summary by Document Date`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-debtor-aging-detail-trx-date/parameters`,
      title: `Debtor Aging Detail by Trx Date`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-debtor-control-summary/parameters`,
      title: `Debtor Control Summary`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/ar-debtor-control-detail/parameters`,
      title: `Debtor Control Detail`,
      deployed: true,
    },
    // {
    //   path: `/digital-reports/account-receivable/sst-tracking-report/parameters`,
    //   title: `SST Tracking Report`,
    //   deployed: isInternalUse ? true : false,
    // },
    // {
    //   path: `/digital-reports/account-receivable/sst-payable-reports/parameters`,
    //   title: `SST Payable Report`,
    //   deployed: isInternalUse ? true : false,
    // },
    {
      path: `/digital-reports/account-receivable/sst-payable-report/parameters`,
      title: `SST Payable and Tracking Report`,
      deployed: isInternalUse ? true : false,
    },
    {
      path: `/digital-reports/account-receivable/sst-exempted-tracking-report/parameters`,
      title: `SST Exempted Tracking Report`,
      deployed: isInternalUse ? true : false,
    },

    // {
    //   path: `/digital-reports/account-receivable/collection-allocation-details-report/parameters`,
    //   title: `Collection Allocation Details Report`,
    //   deployed:
    //     process.env.REACT_APP_LOCAL_DB === 'local' ||
    //     process.env.REACT_APP_LOCAL_DB === 'azure'
    //       ? true
    //       : false,
    // },
    {
      path: `/digital-reports/account-receivable/e-invoice-listing/parameters`,
      title: `e-Invoice Listing`,
      permission:
        AcctPermission.AccReceivableDigitalReportsEinvoiceListingReportView,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/user-login-log-report/parameters`,
      title: `User Login Log Report`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/amortisation-schedule-report/parameters`,
      title: `Amortisation Schedule Report`,
      deployed: true,
    },
    {
      path: `/digital-reports/account-receivable/sst-exempted-tracking-report/parameters`,
      title: `SST Exempted Tracking Report`,
    },
  ]

  // LocalStorage for lastAccessedModule
  localStorage.setItem('lastAccessedModule', 'DIGITAL_REPORTS')

  const backPath = () => {
    if (isHomeDefault === 'true') return history.push(`/`)
    else {
      history.push({
        pathname:
          mode === 'general-ledger'
            ? `/general-ledger/${CompanyID}`
            : mode === 'cash-book'
            ? `/cash-book/${CompanyID}`
            : mode === 'account-receivable'
            ? `/account-receivable/${CompanyID}`
            : mode === 'general-purchase'
            ? `/general-purchase/${CompanyID}`
            : mode === 'inventory-control'
            ? `/inventory-control/${CompanyID}`
            : mode === 'fixed-assets'
            ? `/fixed-assets/${CompanyID}`
            : `/account-payable/${CompanyID}`,
      })
    }
  }

  const handleChange = value => {
    history.push({ pathname: value })
  }

  let package_permission
  if (!packageLoading) {
    package_permission = dropdownOption.filter(
      (v, i) =>
        getPackageByAccount?.includes(v?.package_name) ||
        v?.package_name === 'ACCESS_SECURITY'
    )
  }

  useEffect(() => {
    if (user?.accountID) {
      loadPackage({
        variables: { softwareCode: 'ACCOUNT', accountID: user?.accountID },
      })
    }
  }, [user?.accountID])

  return (
    <>
      {packageLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={backPath}
        smTitle={'Account Receivable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Digital Reports', current: true },
        ]}
      />
      <DynamicSubHeader
        title={labelState}
        handleClick={e => {
          handleClick(e)
        }}
        dropDownOptions={
          <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {package_permission?.map(x => {
              if (handlePermHidden({ permEnum: x?.permission }))
                return (
                  <StyledMenuItem
                    onClick={e => {
                      // setLabelState(x?.label)
                      handleChange(x?.path)
                      handleClose()
                    }}
                    selected={location.pathname.includes(x.path)}
                  >
                    <ListItemText primary={x.label} />
                  </StyledMenuItem>
                )
            })}
          </StyledMenu>
        }
      />
      <ContentWrapper
        float
        style={{
          marginTop: isDesktop ? '100px' : '40px',
          top: isDesktop ? '47px' : null,
        }}
      >
        <List className="core-list">
          {submenuList.map((el, index) => {
            if (el?.deployed && handlePermHidden({ permEnum: el?.permission }))
              return (
                <ListItem key={index} onClick={() => history.push(el?.path)}>
                  <ListItemText
                    style={{ textAlign: 'right', marginLeft: '5px' }}
                    primary={<span className="xsTitle">{el?.title}</span>}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete">
                      <KeyboardArrowRight
                        onClick={() => history.push({ pathname: el.path })}
                      />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              )
          })}
        </List>
      </ContentWrapper>
    </>
  )
}
